import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import ProjectSummarySettings from "./ProjectSummarySettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const ProjectSummarySettingsModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.listSettings" />} key="2">
            <ProjectSummarySettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default ProjectSummarySettingsModal;
